import {useCallback, useState} from 'react';
import {useDispatch} from 'react-redux';
import {v4 as uuid} from 'uuid';
import {
  ADD_FAILED_PHOTO,
  ADD_PENDING_PHOTO,
  PHOTO_FAILED_REASON_SIZE,
} from '~/ViewInvitation/reducers/constants';
import {TooManyPhotosSelectedModal} from '~/ViewInvitation/routes/Photos/modals';

const FILESIZE_UPLOAD_LIMIT = evite.features.get('photo_sharing_max_file_size');
const FILE_COUNT_UPLOAD_LIMIT = evite.features.get('photo_sharing_max_photos_per_user_per_event');

export const PhotoGalleryUploadInput = ({fileUploadRef, collection = 'photos', onEditGallery}) => {
  const [fileInputValue, setFileInputValue] = useState('');
  const [showTooManyPhotosModal, setShowTooManyPhotosModal] = useState(false);

  const dispatch = useDispatch();

  const handleFileInputChange = useCallback(
    (e) => {
      e.preventDefault();
      const images = e.target.files;

      setFileInputValue('');

      if (images.length > FILE_COUNT_UPLOAD_LIMIT) {
        setShowTooManyPhotosModal(true);
        return false;
      }
      for (const image of images) {
        if (image.size > FILESIZE_UPLOAD_LIMIT) {
          dispatch({
            type: ADD_FAILED_PHOTO,
            payload: {
              id: uuid(),
              file: image,
              collection,
              reason: PHOTO_FAILED_REASON_SIZE,
            },
          });
        } else {
          dispatch({
            type: ADD_PENDING_PHOTO,
            payload: {
              id: uuid(),
              file: image,
              collection,
            },
          });
        }
      }
      onEditGallery();
      return false;
    },
    [dispatch, collection, onEditGallery]
  );

  return (
    <>
      <input
        type="file"
        accept="image/*"
        id="add-photos-file-input"
        data-qa-id="add-photos-input"
        ref={fileUploadRef}
        value={fileInputValue}
        onChange={handleFileInputChange}
        multiple
        hidden
      />
      {showTooManyPhotosModal && (
        <TooManyPhotosSelectedModal onClose={() => setShowTooManyPhotosModal(false)} />
      )}
    </>
  );
};
